import React, { useState } from "react";

import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { add, update } from "../../service/industryService";
import { Button } from "primereact/button";
import { Input } from "../../components/Shared/Forms";
import { InputSwitch } from "primereact/inputswitch";
import { Grid } from "@mui/material";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";

export default function IndustryAdd(modalProps: any) {
  const record = modalProps.record || {};
  const [name, setName] = useState(record?.name || "");
  const [dstiEnabled, setDstiEnabled] = useState(record?.dsti_enabled == undefined ? true : record?.dsti_enabled);

  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});

  async function addIndustry() {
    if (!name || name === "") {
      setFieldErrors({
        name: "Industry name is required",
      });
      return;
    }
    if (record?.id) {
      update({
        id: record.id,
        name,
        dsti_enabled: dstiEnabled,
      }).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Industry Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      add(name, dstiEnabled).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Industry Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <Stack direction="row" spacing={3} sx={{ display: { xs: "none", md: "flex" }, my: 1 }}>
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: "100%" }}>
          <Stack spacing={1}>
            <Input
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Enter name"
              required={true}
              label={"Name"}
              error={fieldErrors.name}
            />
          </Stack>
        </Stack>
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <FormLabel style={{ marginBottom: 10 }}>DSTI Enabled</FormLabel>
          <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" }, gap: 2 }}>
            <InputSwitch checked={dstiEnabled} onChange={e => setDstiEnabled(e.value)} />
          </FormControl>
        </Grid>
      </Grid>
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
